import {
    IonIcon,
    IonButton,
    useIonActionSheet,
    IonNote,
    IonText,
    IonBadge
} from '@ionic/react';
import {
    Row,
    Col
} from 'reactstrap';
import { getMode } from '@ionic/core';
import {
    ellipsisHorizontalSharp,
    ellipsisVerticalSharp,
    pencil,
    close,
    send,
    archive,
    mail,
    cloudDownload,
    cash,
    receipt,
    chevronDownCircleOutline,
    chevronUpCircleOutline,
    people
 } from 'ionicons/icons';
import { useEffect, useState } from 'react';
import { colorTheme, OCCUPANT_TYPE } from '../../utils/constants';


const TenantListItem = ({
    tenantId, tenantName, accountBalance, unitName, propertyName,
    currency, showDetails, handleTenantAction, phoneNumber, accountNumber,
    openTenantAccount, userAllPerms, options, tenant ={}, index
 }) => {

    const [showExtraDetails, setShowExtraDetails] = useState(false);
    const [showAssignTenant, setShowAssignTenant] = useState(tenantName == null || tenantName == "");

    const [present] = useIonActionSheet();

    const [extraData, setExtraData] = useState([])
    useEffect(()=>{
      setExtraData([
        {label: `${options.userAccountType === OCCUPANT_TYPE ? "Tenant" : "Member"}`, value: tenantName},
        {label: 'Property', value: propertyName},
        {label: 'Unit', value: unitName},
        {label: 'Phone Number', value: phoneNumber},
        {label: 'Account Number', value: accountNumber},
        {label: 'Account Balance', value: accountBalance + " " + currency}
    ])
    },[tenant])

    const actionsRequiringAllTenantPerms = ['Edit', 'Delete', 'Archive', 'Unarchive', `Shift ${options.userAccountType === OCCUPANT_TYPE ? "Tenant" : "Member"}`]
    const actionsRequiringAllMsgPerms = ['Send Payment Reminder',  `Send ${options.userAccountType === OCCUPANT_TYPE ? "Tenant" : "Member"}Statement`]
    const actionsRequiringAllInvoicePerms = ['Add Invoice']
    const actionsRequiringAllPaymentPerms = ['Add Payment']

    useEffect(() => {
        setShowAssignTenant(tenantName == null || tenantName == "");
    }, [tenantName])

    const open = async () => {
        const mode = getMode();

        const buttons = [
              {
                text: 'Edit',
                role: 'destructive',
                icon: mode !== 'ios' ? pencil : '',
                handler: () => {
                  handleTenantAction("edit", tenantId);
                },
              },
              ...(accountBalance > 0 ? [{
                text: 'Send Payment Reminder',
                icon: mode !== 'ios' ? send : '',
                handler: () => {
                    handleTenantAction("sendPaymentReminder", tenantId);
                },
              }] : []),
              {
                text: 'Send Message',
                icon: mode !== 'ios' ? mail : '',
                handler: () => {
                  handleTenantAction("sendMessage", tenantId);
                },
              },
              {
                text: `Send ${options.userAccountType === OCCUPANT_TYPE ? "Tenant" : "Member"} Statement`,
                icon: mode !== 'ios' ? mail : '',
                handler: () => {
                  handleTenantAction("sendTenantStatement", tenantId);
                },
              },
              {
                text: `Download ${options.userAccountType === OCCUPANT_TYPE ? "Tenant" : "Member"} Transactions (PDF)`,
                icon: mode !== 'ios' ? cloudDownload : '',
                handler: () => {
                  handleTenantAction("downloadTenantTransactions", tenantId);
                },
              },
              {
                text: `Download  ${options.userAccountType === OCCUPANT_TYPE ? "Tenant" : "Member"} Transactions (CSV)`,
                icon: mode !== 'ios' ? cloudDownload : '',
                handler: () => {
                  handleTenantAction("downloadCSV", tenantId);
                },
              },
              {
                text: `Shift ${options.userAccountType === OCCUPANT_TYPE ? "Tenant" : "Member"}`,
                icon: mode !== 'ios' ? people : '',
                handler: () => {
                  handleTenantAction("shiftTenant", tenantId);
                },
              },
              {
                text: tenant?.archived ? 'Restore': 'Delete',
                icon: mode !== 'ios' ? archive : '',
                handler: () => {
                  handleTenantAction(tenant?.archived ? 'unarchive': 'archive', tenantId);
                },
              },
              {
                text: 'Add Invoice',
                icon: mode !== 'ios' ? receipt : '',
                handler: () => {
                  handleTenantAction("addInvoice", tenantId);
                },
              },
              {
                text: 'Add Payment',
                icon: mode !== 'ios' ? cash : '',
                handler: () => {
                  handleTenantAction("addPayment", tenantId);
                },
              },
              {
                text: 'Cancel',
                role: 'cancel',
                icon: mode !== 'ios' ? close : '',
                handler: () => {
                },
              },
            ];

            let filteredButtons = buttons;
            if(!userAllPerms.tenant){
              filteredButtons = filteredButtons.filter((b) => !actionsRequiringAllTenantPerms.includes(b.text));
            }
            if(!userAllPerms.message){
              filteredButtons = filteredButtons.filter((b) => !actionsRequiringAllMsgPerms.includes(b.text));
            }
            if(!userAllPerms.invoice){
              filteredButtons = filteredButtons.filter((b) => !actionsRequiringAllInvoicePerms.includes(b.text));
            }
            if(!userAllPerms.payment){
              filteredButtons = filteredButtons.filter((b) => !actionsRequiringAllPaymentPerms.includes(b.text));
            }

        present({
            header: tenantName + "  " + accountBalance + " " + currency,
            buttons: filteredButtons
          });

      }

      useEffect(() => {
        setShowExtraDetails(showDetails);
    }, [showDetails]);

    return (<div className='mx-2 mx-md-4' key={tenantId}>
        <Row className='my-2 py-1 px-0 shadow-sm rounded'>
          <Row className='rounded mx-0 px-0'
          >
            <Col id='tenant-page-expand-details' className='mx-0 pr-1' onClick={ () => { setShowExtraDetails(!showExtraDetails)} }
              xs={8} md={6}
            >
              <Row className='mx-0 px-0'>
              <Col className='mx-1 px-0' xs={12} md={5}>
                <strong id={'tenant-name-container' + index}>{tenantName}&nbsp;
                  <IonIcon
                    style={{fontSize: '20px', color: 'var(--ion-color-primary)'}}
                    icon={!showExtraDetails ? chevronDownCircleOutline : chevronUpCircleOutline}
                  ></IonIcon>
                </strong> &nbsp;
                {tenant?.archived && <IonBadge className="" color="danger">Deleted</IonBadge>}
              </Col>
              <Col className='mx-1 px-0' xs={12} md={5}>
                <IonNote className='text-sm'>{unitName}{(unitName && propertyName)? " | ": ""}
                </IonNote> &nbsp;
                <IonNote className='text-sm'>
                  {propertyName}
                </IonNote>
              </Col>
              </Row>
            </Col>

            <Col xs={3} md={5} className='flex justify-content-end justify-content-md-start px-0 mx-0'>
              <IonText>
                <strong>{accountBalance}</strong>
              </IonText> &nbsp;
                <p><span style={{fontSize: '10px'}}>{currency}</span></p>
            </Col>


            <div onClick={open} style={{width: '25px', color: 'var(--ion-color-primary)'}} className='my-0 px-0 py-1 d-block d-md-none'>
                  <IonIcon  size="large" aria-hidden="true"  icon={ellipsisVerticalSharp} />
            </div>
            <div style={{width: '50px', color: 'var(--ion-color-primary)'}} className='my-0 px-0 py-0 d-none d-md-block'>
                  <IonIcon id='tenant-page-menu-items' onClick={open} size="large" aria-hidden="true"  icon={ellipsisHorizontalSharp} />
            </div>
          </Row>

            {showExtraDetails && (<Row style={{backgroundColor: colorTheme["primary"]["25"] }}
              className='mx-0 px-0 mb-2 py-3 rounded tenant-list-row'>
              <Row className="mb-2">
                <IonButton onClick={() => openTenantAccount(tenantId)}>View Transactions</IonButton>
              </Row>
              <Row>
                <IonButton 
                  fill="outline"
                  onClick={(e) => {
                    e.stopPropagation();
                    open();
                  }}
                >
                  Options
                </IonButton>
              </Row>
              {extraData.map((data, index) => (
                    <Row key={index} className='border-bottom my-1 mx-1'>
                      <Col className='px-0' xs={4} md={3}><strong>{data.label}</strong></Col>
                      <Col xs={8} md={8}>
                        <span style={{fontSize: '16px'}}>{data.value}</span>
                      </Col>
                    </Row>))}
            </Row>)}
        </Row>
    </div>);
}

export default TenantListItem;